'use strict';

angular.module('directives.scrollArrowIndicator', [])
    .directive('appendFloatingArrow', ['$window', '$timeout', function ($window, $timeout) {
        return {
            restrict: 'A',
            scope: {},
            link: function (scope, element, attributes) {

                console.log('appendFloatingArrow');
                var windowElement;
                var offsetTop;
                var containerHeight;
                var viewportHeight;
                var scrollY;
                var FLOATER_MARGIN = 30;
                var el;

                $window = angular.element($window);

                function getDistanceFromTopOfPage(e) {
                    var offsetTotal = 0;
                    var tmpElement = e[0];
                    while (tmpElement) {
                        offsetTotal = offsetTotal + tmpElement.offsetTop;
                        tmpElement = tmpElement.offsetParent;
                    }
                    return offsetTotal;
                }

                function renderArrow() {
                    offsetTop = getDistanceFromTopOfPage(element);
                    containerHeight = element.height();
                    viewportHeight = angular.element($window).innerHeight();
                    scrollY = $window[0].pageYOffset;

                    el = angular.element('<div class="floater"><div class="arrow bounce"><a class="fa fa-arrow-down fa-2x"></a></div></div>');
                    element.append(el);
                };

                /**
                 * This function keeps the arrow at a seemingly fixed position on the screen, but it is really just changing the "bottom" property as the user scrolls
                 * The reason it's done this way, as opposed to just position:fixed is because we want it to be fixed relative only to one component on the screen (i.e. the container)
                 * In more modern browsers, position:sticky accomplishes this, but this is compatible with <=IE11
                 */
                function adjustArrowLocationOnScroll(event, containerHeight) {
                    containerHeight = containerHeight || element.height();
                    offsetTop = getDistanceFromTopOfPage(element);
                    scrollY = $window[0].pageYOffset;
                    var calculatedFloaterPos = (viewportHeight + scrollY - (offsetTop + containerHeight));

                    /*console.group();
                    console.log('containerHeight', containerHeight);
                    console.log('scrollY', scrollY);
                    console.log('offsetTop', offsetTop);
                    console.log('calculatedFloaterPos', calculatedFloaterPos);
                    console.groupEnd();*/

                    var newFloaterPos;
                    if (calculatedFloaterPos < FLOATER_MARGIN) { // i.e. show arrow as long as floater is positioned <FLOATER_MARGIN> above the bottom. We don't want the floater to be visible once container's bottom is scrolled into view
                        el.css({
                            'bottom': (calculatedFloaterPos * -1) + 'px',
                            'opacity': '1',
                            'zIndex': '30'
                        });
                    } else {
                        el.css({
                            'opacity': '0',
                            'zIndex': '-1'
                        });
                    }
                }

                // Do all the work inside $timeout so content loads and settles. Otherwise initial measurements will be wrong
                $timeout(function () {
                        $window.on('scroll', adjustArrowLocationOnScroll);
                        scope.$on('$destroy', function () {
                            $window.off('scroll', adjustArrowLocationOnScroll);
                        });
                        renderArrow();
                        $window.scroll(); // manually trigger scroll just once so that arrow appears immediately on page load (if needed, TBD by handler)

                        scope.$watch(
                            function () {
                                return element[0].offsetHeight;
                            },
                            function (newHeight, oldHeight) {
                                adjustArrowLocationOnScroll(null, newHeight);
                            }
                        );
                });
                
            }
        }
    }]);